module.exports = __webpack_public_path__ + "img/ico_pizza_blanco.30b0fddc.svg";